export const COMPLETE_INPUT_LENGTH = 8

